import React from "react"
import { useTranslation } from "react-i18next"
import { t } from 'i18next'
import {
  Accordion, AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  LinearProgress,
  Stack,
  TableCell,
  TableRow, Tooltip,
  Typography,
  Button,
  Avatar,
} from '@mui/material'

import { useTableStyles } from '../datatable/hook/useStyles'
import { DataTable } from "../datatable"
import dashboard_ from "../../sass/dashboard.module.sass"
import table_ from '../../sass/table.module.sass'
import { Subscriber } from "../../store/user/reducer"
import { HeaderData, TableRef } from '../datatable/types'
import { formatDate, getNow } from '../../function/date'
import { SearchResult, Type } from '../../store/searcher/reducer'
import { useInProgressStyles } from '../../style/progress'
import { useTransparentAccordionStyles } from '../../style/accordion'
import sprite_ from '../../sass/sprite.module.sass'
import * as XLSX from 'xlsx'
import { addHyperlinksToColumn, addPlaceHyperlinks, autoFitColumns, cleanJSON, generateXLSXDataEmails, generateXLSXDataPhones, toAvatarLink } from "../../function/string"

interface Props {
  data: Subscriber
}

const tableLimit = 20

export function getSearchType(type: Type) {
  switch (type) {
    case 'phone':
      return t('searcher.type.phone')
    case 'name':
      return t('searcher.type.name')
    case 'name_api' :
      return t('searcher.type.name_api')
    case 'post':
      return t('searcher.type.post')
    case 'deepweb':
      return t('searcher.type.deepweb')
    case 'combined_phone':
      return t('searcher.type.combined_phone')
    case 'combined_email':
      return t('searcher.type.combined_email')
    case 'combined_name':
      return t('searcher.type.combined_name')
    case 'combined_id':
      return t('searcher.type.combined_id')
    case 'face_search':
      return t('searcher.type.face_search')
    case 'irbis_eye':
      return t('searcher.type.irbis_eye')
    case 'sentiment_analysys':
      return t('searcher.type.sentiment_analysys')
    case 'web_data_search':
      return t('searcher.type.web_data_search')
    case 'kyc':
      return t('searcher.type.kyc')
    case 'web_collection':
      return t('searcher.type.web_collection')
    case 'ip_geo':
      return t('searcher.type.ip_geo')
    case 'name_by_country':
      return t('searcher.type.name_by_country')
    case 'photo_searcher':
        return t('searcher.type.sniper_api')
    case 'ipgeo_number':
        return t('searcher.type.ipgeo_number')
    case 'fb_person_wall_keyword':
      return t('searcher.type.fb_person_wall_keyword')
    case 'psycho_profile' : 
      return t('searcher.type.psycho_profile')
    case 'psycho_profile_summary' : 
      return t('searcher.type.psycho_profile_summary')
    case 'api_v2_x': 
      return t('searcher.type.api_v2_x')
    case 'api_v2_instagram' : 
      return t('searcher.type.api_v2_instagram')
    case 'api_v2_linkedin' :
      return t('searcher.type.api_v2_linkedin')
    case 'phone_list' :
        return t('searcher.type.phone_list')
    case 'email_list' :
        return t('searcher.type.email_list')
    case 'sn_api_profiler' : 
      return t('searcher.type.sn_api_profiler')
    case 'sn_api_group_profiler' : 
      return t('searcher.type.sn_api_group_profiler')
    case 'lookup_phone_name_verification': 
      return t('searcher.type.lookup_phone_name_verification')
      case 'real_phone':
        return t('searcher.type.real_phone')
      case 'sn_api_profiler_fb_friends' : 
        return t('searcher.type.sn_api_profiler_fb_friends')
      case 'sn_api_profiler_fb_posts' : 
        return t('searcher.type.sn_api_profiler_fb_posts')
      case 'sn_api_profiler_insta_friends' : 
        return t('searcher.type.sn_api_profiler_insta_friends')
      case 'sn_api_profiler_insta_posts' : 
        return t('searcher.type.sn_api_profiler_insta_posts')
      case 'irbis_facebook' :
        return t('searcher.type.irbis_facebook')
      case 'irbis_instagram' :
          return t('searcher.type.irbis_instagram')
      case 'crolo_x' : 
        return t('searcher.type.crolo_x')
      case 'crolo_vk' : 
        return t('searcher.type.crolo_vk')
      case 'crolo_ok' : 
        return t('searcher.type.crolo_ok')
      case 'irbis_criminal' : 
        return t('searcher.type.irbis_criminal')
      case 'ssn_trace' : 
        return t('searcher.type.ssn_trace')
      case 'nat_crim_check' : 
        return t('searcher.type.nat_crim_check')
      case 'pep' : 
        return t('searcher.type.pep')
      case 'irbis_tiktok' : 
        return t('searcher.type.irbis_tiktok')
      case 'court_records' :
        return t('searcher.type.court_records')
      case 'crypto_wallet_screening' :
        return t('searcher.type.crypto_wallet_screening')
      case 'region_monitoring' :
        return t('searcher.type.region_monitoring')
      case 'region_monitoring_entities_extract' :
        return t('searcher.type.region_monitoring_entities_extract')
      case 'irbispro_conclude_report' : 
        return t('searcher.type.irbispro_conclude_report')
      case 'bluesky_v3' : 
        return t('searcher.type.bluesky_v3')
      case 'image_insize' : 
        return t('searcher.type.image_insize')
      case 'adid_by_phone' : 
        return t('searcher.type.adid_by_phone')
      case 'adid_location' : 
        return t('searcher.type.adid_location')
      case 'profiler' : 
        return t('searcher.type.profiler')
      case 'public_company_info':
        return t('searcher.type.public_company_info')
  }
}

  export async function handleDownloadPdf(e: React.MouseEvent, row: SearchResult) {

    if (row.type === 'profiler') {
      const allData: any = row

      const pdfLink: any | undefined =
        allData?.apiDataEntities?.find((item: any) => item.from === 'pdf_report')?.data?.pdfReport

      if (!pdfLink) return

      let filename = `${row.criteria ?? 'report'}-${row.createdTime ?? Date.now()}.pdf`

      try {
        const last = pdfLink.split("/").pop() ?? ""
        filename = decodeURIComponent(last)
          .replace(/%20/g, "_")
          .trim()
      } catch (e) {

      }

      const res = await fetch(pdfLink, {
        method: "GET",
      })

      if (!res.ok) throw new Error(`Download failed: ${res.status} ${res.statusText}`)

      const blob = await res.blob()

      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = filename
      a.style.display = "none"
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
    }
  }

  export function handleDownloadXlsxPhones(e: React.MouseEvent, row: SearchResult) {
    e.stopPropagation()
    const json: any = cleanJSON(row)
    const data = JSON.parse(json)

    const lookupData = generateXLSXDataPhones(data)

    const workbook = XLSX.utils.book_new()
    try {
      const worksheet = XLSX.utils.json_to_sheet(lookupData)

      const objectMaxLength: any[] = []

      lookupData.forEach((row: any) => {
        Object.keys(row).forEach((key, index) => {
          const columnLength = row[key] ? row[key].toString().length : 10
          objectMaxLength[index] = Math.max(objectMaxLength[index] || 10, columnLength)
        })
      })

      worksheet['!cols'] = objectMaxLength.map(width => {
        return { width: width + 3 }
      })

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1")
    } catch (e) {

    }
    XLSX.writeFile(workbook, "DataSheet.xlsx")
  }

  export function handleDownloadXlsxEmails(e: React.MouseEvent, row: SearchResult) {
    e.stopPropagation()

    const lookupData = generateXLSXDataEmails(row)

    const overview: any[] = []
    const socials: any[] = []
    const breaches: any[] = []
    const glook: any[] = []
    const teams: any[] = []

    for (const email in lookupData) {
      const item = lookupData[email]

      overview.push({
        Email: email,
        Name: item?.glook?.gaia?.contributor?.name || item?.teams?.name || '',
        Points: item?.glook?.gaia?.contributor?.points || 0,
        Breaches: (item?.hbp || []).filter((x: any) => x?.Name).length,
        Socials: (item?.smf || []).filter((x: any) => x?.social).length,
        ...Object.fromEntries(
          (item?.glook?.gaia?.reviews || [])
            .map((review: any, index: number) => {
              const lat = review?.place_info?.gps_coordinates?.latitude
              const lng = review?.place_info?.gps_coordinates?.longitude

              if (lat == null || lng == null) return null

              return [
                `Place ${index + 1}`,
                `${review.place_info.title}`,
              ]
            })
            .filter(Boolean),
        ),
      })

      for (const s of item?.smf || []) {
        if (!s?.social) continue
        socials.push({
          Email: email,
          Platform: s.social,
          URL: s.socialProfileUrl || '',
        })
      }

      for (const b of item?.hbp || []) {
        if (!b?.Name) continue
        breaches.push({
          Email: email,
          Name: b.Name,
          Domain: b.Domain || '',
          Date: b.BreachDate || '',
          PwnCount: b.PwnCount || '',
        })
      }

      if (item?.glook?.gaia?.contributor) {
        const c = item.glook.gaia.contributor
        glook.push({
          Email: email,
          Name: c.name || '',
          Level: c.level || '',
          Points: c.points || '',
          Reviews: c.contributions?.reviews || 0,
          Photos: c.contributions?.photos || 0,
          Avatar: toAvatarLink(c.thumbnail),
        })
      }

      if (item?.teams) {
        teams.push({
          Email: email,
          Name: item.teams.name || '',
          SkypeId: item.teams.skype_id || '',
          Avatar: toAvatarLink(item.teams.avatar),
        })
      }
    }

    const wb = XLSX.utils.book_new()

    const overviewSheet = XLSX.utils.json_to_sheet(overview)
    const baseHeaders = ['Email', 'Name', 'Points', 'Breaches', 'Socials']

    const placeHeaders = Array.from(
      new Set(
        overview.flatMap((row: any) =>
          Object.keys(row).filter((key) => key.startsWith('Place ')),
        ),
      ),
    )

    const overviewHeaders = [...baseHeaders, ...placeHeaders]
    autoFitColumns(overviewSheet, overview)

    const socialsSheet = XLSX.utils.json_to_sheet(socials)
    autoFitColumns(socialsSheet, socials)

    const breachesSheet = XLSX.utils.json_to_sheet(breaches)
    autoFitColumns(breachesSheet, breaches)

    const glookSheet = XLSX.utils.json_to_sheet(glook)
    autoFitColumns(glookSheet, glook)

    const teamsSheet = XLSX.utils.json_to_sheet(teams)
    autoFitColumns(teamsSheet, teams)

    addHyperlinksToColumn(glookSheet, glook, 'Avatar')
    addHyperlinksToColumn(socialsSheet, socials, 'URL')
    addPlaceHyperlinks(overviewSheet, overview, lookupData, overviewHeaders)

    XLSX.utils.book_append_sheet(wb, overviewSheet, 'Overview')
    XLSX.utils.book_append_sheet(wb, socialsSheet, 'Socials')
    XLSX.utils.book_append_sheet(wb, breachesSheet, 'Breaches')
    XLSX.utils.book_append_sheet(wb, glookSheet, 'Glook')
    XLSX.utils.book_append_sheet(wb, teamsSheet, 'Teams')

    XLSX.writeFile(wb, 'report.xlsx')
  }

function isTelegramBotImage(base64 : string) {
  if (!base64.includes('data:image/jpeg;base64')) {
    base64 = 'data:image/jpeg;base64' + base64 
  }
  return base64
}

export function SubscriberRequests({ data }: Props) {
  //call hooks
  const { t } = useTranslation()
  const tableClasses = useTableStyles()
  const progressInClasses = useInProgressStyles()
  const transparentAccordion = useTransparentAccordionStyles()
  const tableRef = React.useRef<TableRef>(null)

  //handlers
  const handleRowClick = (row: SearchResult) => {
    window.open(`/result/${row.id}`, '_blank', 'noopener,noreferrer')
    return false
  }
  function handleDownload(e: React.MouseEvent, row: SearchResult) {
    e.stopPropagation()
    const json = JSON.stringify(row)
    const blob = new Blob([json], { type: 'application/json' })
    const href = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = href
    link.download = `${row.type}_${getNow()}.json`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  //helpers 
  const tableHeaderData: HeaderData[] = [
    { key: 'criteria', text: t('searcher.table.criteria') },
    { key: 'type', text: t('searcher.table.type') },
    {
      key: 'date',
      text: t('searcher.table.date'),
      sortable: true,
      defaultSort: true,
      className: 'wideVisible',
    },
    {
      key: 'status',
      text: t('searcher.table.status'),
      style: { minWidth: 210 },
      className: 'wideVisible',
    },
    {
      key: 'sources',
      text: t('searcher.table.sources'),
      style: { width: 100 },
      className: 'wideVisible',
    },
    {
      key: 'isDeleted',
      text: 'Request label',
      style: { width: 100 },
      className: 'wideVisible',
    },
    {
      key: 'actions',
      text: t('searcher.table.actions'),
      style: { width: 110 },
    },
  ]
  const RenderTableBody = (row: SearchResult, idx: number) => {
    return (
      <TableRow key={row.id} className={idx % 2 !== 0 ? tableClasses.rowEven : ""} onClick={() => handleRowClick(row)} style={{cursor: 'pointer'}}>
      { (row.type === 'face_search' || row.type === 'irbis_eye' || row.type === 'photo_searcher' ? (
        <TableCell>
          <Avatar alt="Remy Sharp" src={row.criteria} />
        </TableCell>
      ) : (
        row.type === 'sentiment_analysys' && row.criteria.length > 25 ?
          <TableCell>{row.criteria.substr(0,25) + "..."}</TableCell> :
          <TableCell style={{overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px'}}>{row.criteria}</TableCell>
      ))
      }
        <TableCell>{getSearchType(row.type)}</TableCell>
        <TableCell className="wideVisible">{formatDate(row.createdTime, 'dd/MM/yyyy HH:mm:ss')}</TableCell>
        <TableCell className="wideVisible">
          {row.status === 'progress' && row.percentage ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Typography noWrap>{t('searcher.status.progress')}</Typography>
              <Box width="60%">
                <LinearProgress
                  variant="determinate"
                  color="success"
                  value={Number(row.percentage)}
                />
              </Box>
            </Stack>
          ) : row.status === 'finished' ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Typography noWrap>{t('searcher.status.finished')}</Typography>
              <Box width="60%">
                <LinearProgress
                  variant="determinate"
                  color="success"
                  value={100}
                />
              </Box>
            </Stack>
          ) : row.status === 'failed' ? (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Typography noWrap>Failed</Typography>
              <Box width="60%">
                <LinearProgress variant="determinate" value={0} />
              </Box>
            </Stack>
          ) : row.status === 'empty' ? (
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <Typography noWrap>{t('searcher.status.empty')}</Typography>
            <Box width="60%">
              <LinearProgress
                variant="determinate"
                color="success"
                value={100}
              />
            </Box>
          </Stack>
          ) : (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Typography noWrap>{t('searcher.status.progress')}</Typography>
              <Box width="60%">
                <LinearProgress
                  classes={progressInClasses}
                  variant="determinate"
                  value={100}
                />
              </Box>
            </Stack>
          )}
        </TableCell>
        <TableCell className="wideVisible">
          <Accordion
            classes={transparentAccordion}
            //onClick={(e) => handleSourceClick(e, row)}
            expanded={
              row.status === 'progress' && row.percentage ? undefined : false
            }
            disabled={row.status === 'finished'}
          >
            <AccordionSummary>
              <Stack direction="row" spacing={1} width={'200px'} flexWrap={'wrap'} gap={'10px'}>
                { row.type !== 'api_v2_x' && row.type !== 'api_v2_instagram' && row.type !== 'api_v2_linkedin' ? 
                row.sources.map((el, idx) => (
                  <Box
                    key={idx}
                    className={(el.name === 'fb_api' || el.name === 'instagram_api' || el.name === 'vk_api' 
                      || el.name === 'ok_api' || el.name === 'x_api' || el.name === 'linkedin_api' 
                        || el.name === 'tiktok_api' || el.name === 'blsk_api' || el.name === 'webmii_social') 
                    ? sprite_['social__small_' + el.name.replace("_api","")] : sprite_['social__small_' + el.name]}
                    marginLeft={'0!important'}
                  />
                )) : 
                row.sources.map((el, idx) => (
                  <Box> {el.name} </Box>
                ))
                }
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              {row.sources.map((el, idx) => (
                <Stack
                  key={idx}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <Box className={sprite_['social__small_' + el.name]} />
                  <Box width="60%">
                    <LinearProgress
                      variant="determinate"
                      color="success"
                      value={Number(el.percentage) || 0}
                    />
                  </Box>
                </Stack>
              ))}
            </AccordionDetails>
          </Accordion>
        </TableCell>

        <TableCell>
        {row.isDeleted && (
          <Box className={table_.status_deleted}>DELETED</Box>
        )}
        </TableCell>

        <TableCell>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            {row.type === 'phone_list' && (
              <Tooltip title={<span>{t('common.downloadXLSX')}</span>}>
                <IconButton
                  onClick={(e) => handleDownloadXlsxPhones(e, row)}
                  disabled={row.status !== 'finished'}
                  size="small"
                >
                  <Box
                    className={sprite_.common__downloadNew}
                  />
                </IconButton>
              </Tooltip>
            )}

            {row.type === 'email_list' && (
              <Tooltip title={<span>{t('common.downloadXLSX')}</span>}>
                <IconButton
                  onClick={(e) => handleDownloadXlsxEmails(e, row)}
                  disabled={row.status !== 'finished'}
                  size="small"
                >
                  <Box
                    className={sprite_.common__downloadXlsx}
                  />
                </IconButton>
              </Tooltip>
            )}

            {row.type === 'profiler' && (
              <Tooltip title={<span>{t('common.downloadPdf')}</span>}>
                <IconButton
                  onClick={(e) => handleDownloadPdf(e, row)}
                  disabled={row.status !== 'finished'}
                  size="small"
                >
                  <Box
                    className={sprite_.common__downloadPdf}
                  />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title={<span>{t('common.download')}</span>}>
              <IconButton
                onClick={(e) => handleDownload(e, row)}
                size="small"
              >
                <Box
                  className={sprite_.common__download}
                />
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </TableRow>
    )
  }

  return (
    <>
      <Typography variant="semiBold" fontSize={18}>
        {t("dashboard.subscriberRequests")}
      </Typography>

      <Box className={dashboard_.card_column} mt={1}>
        <DataTable
          ref={tableRef}
          id="searcher"
          url={`/request-monitor/userwithdeleted/${data.uid}`}
          className={tableClasses.card}
          headerData={tableHeaderData}
          renderBody={RenderTableBody}
          title={t('searcher.table.title')}
          limit={tableLimit}
          pagination
          // refreshPerSeconds={10}
          selectable={false}
          onRowClick={handleRowClick}
          emptyText={
            <Typography variant="light" width={380} fontSize={18} align="center">
              {t('searcher.table.emptyText')}
            </Typography>
          }
          loadingIndication={true}
        />
      </Box>
    </>
  )
}
